<template> 
  <div> 
    <!---综合组件--->
    <template v-for="(item,index) in contents" :key="index">
      <!-- 使用卡片包裹 -->
      <div v-if="item['u']!==false" :style="cardH">
        <VarCard :id="`${pid}_${index}`" 
          style="position: relative;" 
          :style="genStylex(item['css'], item['mcss'])" 
        >
            <template v-for="(subits, subIndex) in item['items']" :key="subIndex">
                <contentitem v-if="subits['v'] !== false" :item="subits" :route-params="routeParams"
                :prepair="item['prepair']" :param-form-data = "paramFormData"></contentitem>
            </template>
        </VarCard>
      </div>
      <!-- 不使用卡片时，直接渲染 item.items，与 tdesign 版本一致 -->
      <div v-else :style="genStylex(item['css'], item['mcss'])" style="padding:8px 16px">
        <template v-for="(subits, subIndex) in item['items']" :key="subIndex">
          <contentitem v-if="subits['v'] !== false" :item="subits"
            :param-form-data = "paramFormData" :route-params="routeParams"
            :prepair="item['prepair']" />
        </template>
      </div>
    </template>

    <!--弹框组件-->
    <template v-for="(item, cindex) in dialogs" :key="cindex">
        <Dialog v-if="item['v']!==false" :config="item" :param-form-data = "paramFormData"></Dialog>
    </template>

  </div>
</template>
<script setup lang="ts">

import { Card as VarCard } from '@varlet/ui';
import '@varlet/ui/es/card/style/index';
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useSettingStore } from '../../store/modules/setting';
import mitt from 'mitt-utils';
import { docCssByCls, docCssById, generateToast, isJsonV, isN, isNN, toast } from '../../utils/tools';
import { exeAction, getPid } from 'exeAction-utils';
import { genStylex } from '../actionUtils/cssUtils';
import Dialog from './v_dialog.vue';
import contentitem from './component_item.vue';
import ws from '../../utils/ws';

//------------------FrontContent----------------------
//todo 此处有个设计问题。content的title并没有实现
//content的card都有id，且用{}括起来，避免与主动设置的冲突
let frontId:number = new Date().getTime();
const route = useRoute();
let router: any = undefined;
try {
  router = useRouter();
} catch (e) {
  router = undefined;
}
let pid = getPid(route);

let setStore = null;
try {
  setStore = useSettingStore();
} catch (error) {
  // 创建一个默认的 store 对象
  setStore = {
    mode: 'light',
    brandTheme: 'default',
    displayMode: 'light',
    // 添加其他可能需要的默认属性
  };
}

const props = defineProps({
  pconfig: {
    type: Object,
    default: ()=>{return {};}
  },
  paramFormData: {
    type: Object,
    default: ()=>{return {};}
  },
  routeParams: {
    type: Object,
    default: ()=>{return {};}
  },
  mitttype: {
    type: String,
    default: ''
  }
});

const n = `${route?.path || 'unknown-route'} content > `;

const navByLocation = (target: string, query?: any) => {
  try {
    let qs = '';
    if (query && typeof query === 'object') {
      try {
        const sp = new URLSearchParams();
        Object.keys(query).forEach((k) => {
          const v = query[k];
          if (v === undefined || v === null) return;
          sp.set(k, `${v}`);
        });
        const s = sp.toString();
        if (s) qs = `?${s}`;
      } catch (e) {
        ;
      }
    }

    let path = target;
    if (!path.startsWith('/')) {
      if (path.startsWith('page/')) {
        path = `/${path}`;
      } else {
        path = `/page/${path}`;
      }
    }

    if (window.location.hash && window.location.hash.startsWith('#')) {
      window.location.hash = `#${path}${qs}`;
    } else {
      window.location.assign(`${path}${qs}`);
    }
  } catch (e) {
    console.error(`${n}navByLocation error`, e);
  }
};

const appMittHandler = (par: any) => {
  try {
    if (!par || !par.flg) return;
    const target = par.flg;
    const p = par.p;
    let query: any = undefined;

    if (Array.isArray(p)) {
      if (p.length === 1 && isJsonV(p[0])) {
        query = p[0];
      } else {
        const merged: any = {};
        p.forEach((it: any) => {
          if (isJsonV(it)) Object.assign(merged, it);
        });
        if (Object.keys(merged).length > 0) query = merged;
      }
    } else if (isJsonV(p)) {
      query = p;
    }

    if (router && typeof router.push === 'function') {
      router
        .push({ name: target, query })
        .catch(() => router.push({ path: target, query }))
        .catch(() => {
          navByLocation(target, query);
        });
    } else {
      navByLocation(target, query);
    }
  } catch (e) {
    console.error(`${n}app_mitt handler error`, e);
  }
};

if (!props.mitttype) {
  mitt.on('app_mitt', appMittHandler);
}

// 传递参数转本页
const parData = ref({});

parData.value = props.paramFormData;

// 页面元素集合
const contents = ref(props.pconfig.contents);
const dialogs = ref(props.pconfig.dialogs);



if(!contents.value){

  toast('空页面');
} else {

}
// 与 tdesign 对齐：把子项的 prepair 同步提升到 content 层
const syncPrepairToContent = (conts:any[]) => {
  if(!Array.isArray(conts)) return;
  conts.forEach((citem:any) => {
    if(!isJsonV(citem['prepair']) && Array.isArray(citem['items'])){
      const sub = citem['items'].find((s:any)=> isJsonV(s['prepair']));
      if(sub && isJsonV(sub['prepair'])){
        try{
          // 使用深拷贝，避免后续对子项 prepair 的变动影响到 content 层
          citem['prepair'] = JSON.parse(JSON.stringify(sub['prepair']));
          // console.log(`${n} sync subitem prepair up to content.`);
        }catch(e){
          citem['prepair'] = sub['prepair'];
        }
      }
    }
  });
};
syncPrepairToContent(contents.value);
//获取字符串类型的路由参数，用于直接给路由
//路由传参也可以实现不走组件ID绑定，而直接用参数传递的方式
let routerPs = {};
if(isJsonV(props.routeParams)){
  for(const key in props.routeParams){
    //数字也传入过去，方便使用vsb获取值
    //key仅适用于这种场景：无组件承载，但是新页面需要这个值
    //if(typeof key === 'string'){
      routerPs[key] = props.routeParams[key];
    //}
  }
}

// 动态宽高
//const divHeight = ref();
//const divWidth = ref();
//provide('divHeight', divHeight);
//provide('divWidth', divWidth);
//divHeight.value = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight; // 兼容性获取屏幕高
//divWidth.value = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

//检测只有一个content的card，如果使用就设置改card的高度100。意图该card充满全屏
let cardHeight = contents.value.length === 1 && contents.value[0]['u']!==false?'100%':undefined;
let cardH = cardHeight?{'height': cardHeight}:undefined;
// 事件监听
let mittName = `${pid}_mitt_dypage_index`;

if(props.mitttype){
  mittName += `_${props.mitttype}`;
}
mitt.on(mittName, (par: any) => {
  try{
    if (par.flg === 'open' || par.flg === 'f_open') {
      const { cdids, dids, itemObj,act } = par;
      if(cdids)
      contents.value = contents.value.map((item) => {
        if (item.idx) {
          if (cdids.findIndex((sut) => sut === item.idx) >= 0) {
            item.v = true;
          }
        }
        return item;
      });


      if(dialogs.value && dids){
        dialogs.value = dialogs.value.map((item) => {
          if (item.idx) {
            if (dids.findIndex((sut) => sut === item.idx) >= 0) {
              item.v = true;
            }
          }
          return item;
        });
      }

      if(isNN(act) && act['trans2ids']){
        // mitt.emit(`${pid}_mitt_did_${act.bdid}`, { flg: 'send_parms', res: act['itemData'], act });
        // setTimeout(()=>{
          act['trans2ids'].forEach(its => {
              dialogs.value = dialogs.value.map((item) => {
                if (item.idx === its) {
                  //  props['paramFormData'] = itemObj;
                }
                return item;
              });
          });
        // },200);
      }

    }else if (par.flg === 'f_close') {
      let act = par['act'];
      if(act){
        let atk = act['k'];
        if(atk && atk.length > 0){
          contents.value = contents.value.map((item) => {
            if (item.idx) {
              if (atk.findIndex((sut) => sut === item.idx) >= 0) {
                item.v = false;
              }
            }
            return item;
          });
          dialogs.value = dialogs.value.map((item) => {
            if (item.idx) {
              if (atk.findIndex((sut) => sut === item.idx) >= 0) {
                item.v = true;
              }
            }
            return item;
          });
        }
      }
    }else if (par.flg === 'f_refreshAction') {
      let rkey = par.rkey;
      let rval = par.rval;
      //此处的===比较不对，一个是字符，一个是数字。目前屏蔽了该处的触发条件
      let cobj = contents.value.find(its => {return its['idx']===rkey});
      if(cobj){
        if(rval === 0){
          getPrePariLoad(cobj, -1);
        }
      }
    }else if(par.flg === 'bind_trans2ids'){
      let {item, res, act , value} = par;
    }else if(par.flg === 'f_start_cycle'){
      //启动定时任务--因为涉及切换可能会多次触发，只有么有的时候才重新触发
      if(isN(cycleAction)){
        cycleActionFun(contents.value.find(its => {return its['idx']===par.v}), frontId);
      }
    }else if(par.flg === 'f_change_card_style'){
      //必须加时延，否则dom元素可能还没生成。实测1秒可能不行
      let b1 = false;
      let b2 = false;
      let i = 0;
      let intervalId = setInterval(() => {
        if(b1===false)b1 = docCssById(`${pid}_0`, par['id1']);
        //仅作用于当前路由
        if(b2===false)b2 = docCssByCls('.h5_card__body', par['id2']);
        i++;

        //都成功了或者大于3秒跳出
        if((b1===true && b2===true) || i >30)clearInterval(intervalId);
      }, 100);
      /*setTimeout(()=>{
        docCssById(`${pid}_0`, par['id1']);
        //仅作用于当前路由
        docCssByCls('.t-card__body', par['id2']);
      },2000);*/
    }
  }catch(e){
    console.error(`${n}`, e);
  }
});


mitt.on(`apiToast_${frontId}`, (par: any) => {
  generateToast(par);
});

// WebSocket消息处理
const handleWs = (e: any) => {
  const wsmsg = props.pconfig.wsmsg;
  if (Array.isArray(wsmsg)) {
    wsmsg.forEach((item) => {
      exeAction(router, item, {wsmsg: e}, pid, frontId);
    });
  } else {
    exeAction(router, wsmsg, {wsmsg: e}, pid, frontId);
  }
};

onMounted(() => {
  if (props.pconfig?.wsmsg) {
    ws.onEvent(handleWs);
  }
});

onBeforeUnmount(() => {
  mitt.off(`apiToast_${frontId}`);
  if (props.pconfig?.wsmsg) {
    ws.offEvent(handleWs);
  }
});

const getPrePariLoad =(item, parIndex) => {
  let actPrepair  = item['prepair'];
  // 兼容：若content层没有配置prepair，则向下在items中寻找第一个有效的prepair
  if(!isJsonV(actPrepair) && Array.isArray(item['items'])){
    for(const sub of item['items']){
      if(isJsonV(sub['prepair'])){
        actPrepair = sub['prepair'];
        break;
      }
    }
  }
  if(isJsonV(actPrepair)) {
    let subExePar   = {};
    if(actPrepair['p']) subExePar = Object.assign(subExePar , actPrepair['p']);
    if(props['paramFormData']) subExePar = Object.assign(subExePar , props['paramFormData']);


    //把这些参数绑定到p参数上，放到input上如果后面没有vsin，就会丢了
    if(isJsonV(routerPs)){
      if(isN(actPrepair['p'])){
        actPrepair['p'] = {};
      }
      Object.assign(actPrepair['p'], routerPs);
    }
    //setTimeout(()=>{
      exeAction(router, actPrepair, subExePar, pid, frontId);
    //});
  }else{
    console.log(`${n} no prepair found for content index ${parIndex}.`);
  }
}

//不要对多个FrontContent设置Cycle
//这样只有第一个会生效，后面都被前面的判断拦截了
let cycleIntv = ref();
let cycleExecute:string;
let cycleAction:any;
const cycleActionFun=(item:any, frontId:number) =>{
  if(isN(item)){
    return;
  }
  cycleAction  = item['cycle'];
  if(isJsonV(cycleAction) && isNN(cycleAction['p'])){
    cycleExecute = `${cycleAction['p']['{e}']}`;
    //立即执行一次
    if(cycleExecute.includes('[n]')){
      exeAction(router, cycleAction, {}, pid, frontId);
    }

    //换算为秒
    let sec = cycleAction['p']['{t}'];
    if(isNN(sec) && sec >0){
      sec *= 1000;
      cycleIntv.value = setInterval(()=>{
        delete cycleAction['p']['{t}'];//不删除，该参数会带到body上
        exeAction(router, cycleAction, {}, pid, frontId);
      }, sec);
    }
  }
}


const onBeforeLeave =(item) => {
  const actBeforeLeave  = item['leave'];
  if(isJsonV(actBeforeLeave)) {
    let subExePar   = {};
    if(actBeforeLeave['p']) subExePar = Object.assign(subExePar , actBeforeLeave['p']);
    //if(props['paramFormData']) subExePar = Object.assign(subExePar , props['paramFormData']);

    //把这些参数绑定到p参数上，放到input上如果后面没有vsin，就会丢了
    //if(isJsonV(routerPs)){
    //  if(isN(actBeforeLeave['p'])){
    //    actBeforeLeave['p'] = {};
    //  }
    //  Object.assign(actBeforeLeave['p'], routerPs);
    //}

    exeAction(router, actBeforeLeave, subExePar, pid, frontId);
  }
}
/** ********css************* */
const getCardExStyle = (item) => {
  let sobj = {};
  if(item['r'] !== false){
    sobj['border-radius'] = '0px';
  }else if(setStore['cround']>=0){
    sobj['border-radius'] = `${setStore['cround']}px`;
  }
  if(item['ptb']>=0){
  sobj['padding-top'] = `${item['ptb']}px`;
  sobj['padding-bottom'] = `${item['ptb']}px`;
  }
  if(item['plr']>=0){
  sobj['padding-left'] = `${item['plr']}px`;
  sobj['padding-right'] = `${item['plr']}px`;
  }
  return sobj;
};

nextTick(() => {
  console.log(`${n}next Tick prepair`);
  console.log('执行事件-----')
  try{
    let parIndex = 0;
    contents.value.map(item => {
      getPrePariLoad(item, parIndex);
      parIndex += 1;
    //     // if(item['loading']){
    //     //   // item['loading'] = {};
    //     //   item['loading']['v'] = false;
    //     // }
    //     // item['isloading'] = true;
    //     return item;
      });
  }catch(e){
    console.error(`${n}`, e);
  }
});


onMounted(() => {
    //计算顶部高度
    /*nextTick(() => {
      updateMainHeight();
    });
    */

  /*
   try{
     contents.value = contents.value.map(item => {
       if(item['loading']){
         item['loading']['v'] = false;
       }
       return item;
     });
   }catch(e){}*/
});


//let pB = setStore['xf']===1?0:'var(--td-comp-paddingLR-l)';
/* 暂时没处理好，影响不大
if(setStore['xf']===1){
  setTimeout(()=>{
    docCss(`${pid}_0`, 'padding-bottom', 0);
  },1000);
}
*/


onBeforeUnmount(() => {
  //每个元素都执行退出事，可以异步，防止用户感知卡顿
  //->不能添加异步：如果事件中有从组件获取值，异步之后将无法从组件获取值
  //setTimeout(()=>{
    contents.value.forEach(element => {
      onBeforeLeave(element);
    });
  //})  

  //如果在页面切换时执行，则执行一次
  if(isNN(cycleExecute) && cycleExecute.includes('[u]')){
    exeAction(router, cycleAction, {}, pid, frontId);
  }
  cycleAction = undefined;
  if(cycleIntv.value){
    clearInterval(cycleIntv.value);
  }
  mitt.off(mittName);
  mitt.off(`apiToast_${frontId}`);
  if (!props.mitttype) {
    mitt.off('app_mitt', appMittHandler);
  }
});
</script>

<style lang="scss" scoped>


:deep(.var-card__body){
  height: v-bind("cardHeight");
}
/*
放在app.vue中不可行，此时无法获取是否全屏
这个值是与吸底有关，对于吸底的，需要将card的底部设置为padding-bottom：0
从而规避拉到底部时效果不对
这个有个问题是影响全局

:deep(.t-card__body){
  padding-bottom: v-bind("pB");
}
*/

</style>